import CodeEditorAlpinePlugin from './components/code-editor';

document.addEventListener('alpine:init', () => {
    window.Alpine.plugin(CodeEditorAlpinePlugin);
});

let translationStatusPolling;

document.addEventListener('DOMContentLoaded', () => {

    window.addEventListener('start-translation-status-polling', (event) => {
        translationStatusPolling = setInterval(() => {
            Livewire.dispatch('poll-translation-status');
        }, 1000);
    });

    window.addEventListener('stop-translation-status-polling', (event) => {
        clearInterval(translationStatusPolling);
    });

    window.addEventListener('tiptap:disable', (event) => {
        toggleTiptapEditor(true);
    });

    window.addEventListener('tiptap:enable', (event) => {
        toggleTiptapEditor(false);
    });
});

const toggleTiptapEditor = function (isReadOnly) {

    document.querySelectorAll('.ProseMirror').forEach((editor) => {
        editor.setAttribute('contenteditable', isReadOnly ? "false" : "true");
        editor.classList.toggle('pointer-events-none', isReadOnly);
        editor.classList.toggle('opacity-50', isReadOnly);
    });

    // Alle Buttons in Tiptap-Toolbars deaktivieren
    const buttonSelectors = [
        '.tiptap-toolbar button',
        '.tiptap-bubble-menu button',
        '.tiptap-floating-menu button',
        '[data-floating-menu] button',
    ];
    buttonSelectors.forEach(selector => {
        document.querySelectorAll(selector).forEach((button) => {

            button.disabled = isReadOnly;

            button.classList.toggle('opacity-50', isReadOnly);
            button.classList.toggle('cursor-not-allowed', isReadOnly);
            button.classList.toggle('no-hover', isReadOnly);

            if (isReadOnly) {
                button.setAttribute('tabindex', '-1');
                button.setAttribute('title', '');
            } else {
                button.removeAttribute('tabindex');
            }
        });
    });
}

// document.addEventListener('DOMContentLoaded', () => {
//     document.querySelectorAll('.expression-badge').forEach(span => {
//
//         const closestElement = span.closest('[id^="ce-"]');
//
//         if (null !== closestElement) {
//
//             const htmlId = closestElement.getAttribute('id');
//
//             span.addEventListener('dblclick', (event) => {
//                 console.log(htmlId);
//                 Livewire.dispatch('add-text-to-expression-' + htmlId, {text: event.target.textContent});
//             });
//         }
//     });
// });
